import React, { FunctionComponent } from 'react';
import { InjectedIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import CONFIG from './config';
import { Confirmation } from '@nbc-design/confirmation';
import { Button } from '@nbc-design/button';
import { Card } from '@nbc-design/card';
import { Check } from '@nbc-design/icons/lib/web/Check';
import { getTextFactory } from 'utils/TextUtils';

export type ThankYouEsignProps = {
  intl: InjectedIntl;
};

const ThankYouEsign: FunctionComponent<ThankYouEsignProps> = (props: ThankYouEsignProps) => {
  const { intl } = props;
  const { locale } = intl;

  const getText = getTextFactory(intl, 'thankYou');
  const pageTitle = getText('pageTitle');

  return (
    <div data-test="thank_you_esign_form" className="text-center">
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>
      <Confirmation title={pageTitle} appearance="success" />

      <Card className="mb-4">
        <ul className="text-left list-none p-0 m-0">
          <li className="mb-4 relative pl-8 last:mb-0">
            <Check
              title="check"
              size={{ width: 16, height: 16 }}
              className="absolute top-0 left-0 h-4 w-4 text-electric-blue"
              data-test="image_checkIcon"
            />
            {getText('emailSentSoon')}
          </li>
        </ul>
      </Card>

      <Button
        type="link"
        appearance="secondary"
        href={CONFIG.LINKS[locale.toUpperCase()].WEBSITE}
        data-test="link_close"
        className="no-underline m-6"
      >
        {getText('close')}
      </Button>
    </div>
  );
};

export default ThankYouEsign;
